export const downloadUrl = `${process.env.REACT_APP_BACKEND_URL}/api/download/document`